// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ImageZoomModal.css */

.image-zoom-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;              
  background: rgba(0, 0, 0, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  cursor: pointer;
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .image-zoom-modal {
    width: 100%;
    height: 145%; 
  }
}


@media screen and (min-width: 1024px) and (max-width: 1440px) {
  .image-zoom-modal {
    width: 100%;
    height: 150%; 
  }
}

.image-container {
  max-width: 80%;
  max-height: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-container img {
  max-width: 45%;
  max-height: 50%;
  object-fit: contain;
}

.close-icon {
  position: absolute;
  top: 10px;
  /* Adjust the top and right values as needed for your desired position */
  right: 10px;
  cursor: pointer;
  color: white;
  /* Set the color property to a valid color value (e.g., "white") */
  font-size: 24px;
  /* Adjust the font size as needed */
}`, "",{"version":3,"sources":["webpack://./src/components/Defects/DefectDetails/Imagezoom.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;;AAGA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,wEAAwE;EACxE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kEAAkE;EAClE,eAAe;EACf,mCAAmC;AACrC","sourcesContent":["/* ImageZoomModal.css */\n\n.image-zoom-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;              \n  background: rgba(0, 0, 0, 1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  cursor: pointer;\n}\n\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .image-zoom-modal {\n    width: 100%;\n    height: 145%; \n  }\n}\n\n\n@media screen and (min-width: 1024px) and (max-width: 1440px) {\n  .image-zoom-modal {\n    width: 100%;\n    height: 150%; \n  }\n}\n\n.image-container {\n  max-width: 80%;\n  max-height: 80%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.image-container img {\n  max-width: 45%;\n  max-height: 50%;\n  object-fit: contain;\n}\n\n.close-icon {\n  position: absolute;\n  top: 10px;\n  /* Adjust the top and right values as needed for your desired position */\n  right: 10px;\n  cursor: pointer;\n  color: white;\n  /* Set the color property to a valid color value (e.g., \"white\") */\n  font-size: 24px;\n  /* Adjust the font size as needed */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
